import { Menu, MenuItem } from '@mui/material';
import { useId, useState } from 'react';

import { Icon, IconButton } from '@vestigas/ui';

import { type UniversalDrawerFieldConfig } from '../../types';

type FiltersDrawerAddFieldMenuProps = {
  readonly addableFieldConfigs: readonly UniversalDrawerFieldConfig[];
  readonly ariaLabel: string;
  readonly onAddField: (field: string) => void;
};

export function FiltersDrawerAddFieldMenu({
  addableFieldConfigs,
  ariaLabel,
  onAddField,
}: FiltersDrawerAddFieldMenuProps) {
  const menuId = useId();
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorElement);

  if (addableFieldConfigs.length === 0) {
    return null;
  }

  function handleClose() {
    setAnchorElement(null);
  }

  return (
    <div className="flex items-center py-1">
      <IconButton
        aria-controls={isOpen ? menuId : undefined}
        aria-expanded={isOpen ? 'true' : undefined}
        aria-haspopup="menu"
        aria-label={ariaLabel}
        data-testid="universal-filters-drawer-add-field"
        type="button"
        onClick={(event) => {
          setAnchorElement(event.currentTarget);
        }}
      >
        <Icon metaphor="add" />
      </IconButton>
      <Menu
        anchorEl={anchorElement}
        disableRestoreFocus
        id={menuId}
        open={isOpen}
        slotProps={{
          paper: {
            className: 'mt-1 min-w-48 rounded-md shadow-lg',
          },
        }}
        onClose={handleClose}
      >
        {addableFieldConfigs.map((fieldConfig) => (
          <MenuItem
            key={fieldConfig.field}
            className="text-sm"
            onClick={() => {
              onAddField(fieldConfig.field);
              handleClose();
            }}
          >
            {fieldConfig.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
